import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36b0f794"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basket-empty" }
const _hoisted_2 = { class: "basket-empty-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "В корзине пока ничего нет.", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Исправить это просто - перейдите в ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Меню")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Меню")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: {
            name: 'Home',
          },
          class: "basket-empty-menulink"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _hoisted_6
      ])
    ]),
    _createVNode(_component_router_link, {
      to: {
        name: 'Home',
      },
      class: "btn-main"
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    })
  ]))
}